import { IssuedDocumentService } from '@/modules/issued-document/issued-document-service';
import Errors from '@/shared/error/errors';

// action types
export const DO_FETCH = 'doFetch';

// mutation types
export const FETCH_SUCCESS = 'fetchSuccess';
export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_FILTERS = 'setFilters';

const state = {
    rows: [],
    total: 0,
    storeFilters: {},
    currentPage: 1,
    fileDownloadAccessToken: null,
};

const getters = {
    rows: (state) => state.rows || [],
    total: (state) => state.total,
    filters: (state) => state.storeFilters,
    currentPage: (state) => state.currentPage,
    fileDownloadAccessToken: (state) => state.fileDownloadAccessToken,
};

const actions = {
    [DO_FETCH](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'issuedDocument/get', { root: true });
            const sort = '-issued_date';
            const filters = { params: { ...payload, pagination: true, sort } };
            IssuedDocumentService.list(filters)
                .then(({ data, headers }) => {
                    const fileDownloadAccessToken = headers?.['x-file-download-access-token'] || '';
                    context.commit(FETCH_SUCCESS, {
                        rows: data.data,
                        total: data?.pagination?.total,
                        fileDownloadAccessToken,
                    });
                    resolve();
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'issuedDocument/get', { root: true });
                });
        });
    }
};

const mutations = {
    [FETCH_SUCCESS](state, payload) {
        state.rows = payload.rows;
        state.total = payload.total;
        if (payload.fileDownloadAccessToken) {
            state.fileDownloadAccessToken = payload.fileDownloadAccessToken;
        }
    },
    [SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    },
    [SET_FILTERS](state, { key, value }) {
        state.storeFilters[key] = value;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
